'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {

    var columns = [{
        id: 'edit',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return props.onClickEditLegalBrief(col.original.id);
                    } },
                'edit'
            );
        }
    }, {
        Header: 'Id',
        accessor: 'id',
        width: 240
    }, {
        Header: 'Nome',
        accessor: 'name'
    }, {
        id: 'delete',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                {
                    iconClassName: 'material-icons',
                    onClick: function onClick() {
                        return removeLegalBrief(col.original, props);
                    }
                },
                'delete'
            );
        }
    }];

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactTable2.default, {
            data: props.legalBriefs,
            columns: columns,
            loading: props.loading,
            previousText: 'Anterior',
            nextText: 'Pr\xF3xima',
            loadingText: 'Carregando...',
            noDataText: 'N\xE3o foram encontrados pe\xE7as cab\xEDveis para este filtro',
            pageText: 'P\xE1gina',
            ofText: 'de',
            rowsText: 'linhas',
            showPaginationBottom: true,
            width: 100,
            defaultPageSize: 10,
            filterable: true,
            defaultFilterMethod: search
        })
    );
};

function search(filter, row, column) {
    var id = filter.pivotId || filter.id;
    return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
}

function removeLegalBrief(legalBrief, props) {
    var confirm = window.confirm('Voc\xEA deseja deletar o resumo legal ' + legalBrief.name + '?');

    if (confirm) {
        props.removeLegalBrief(legalBrief.id);
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/legalBriefs/LegalBriefsList.js
// module id = 2582
// module chunks = 0